module.exports = __webpack_public_path__ + "static/media/layout_double.3f1178c1.svg";